import r from "./index322.js";
import { resolveComponent as o, createBlock as n, openBlock as s } from "vue";
import i from "./index231.js";
function c(e, p, _, a, m, l) {
  const t = o("ms-ad-place");
  return s(), n(t, {
    placementId: "pc",
    height: e.getMaxHeight(),
    isInDisturber: e.isInDisturber
  }, null, 8, ["height", "isInDisturber"]);
}
const h = /* @__PURE__ */ i(r, [["render", c]]);
export {
  h as default
};
